import React from "react";
import WhatsAppTab from "./WhatsAppTab";
import EmailSetup from "./EmailSetup";
import LanguagesTab from "./LanguagesTab";
import SmsSetup from "./SmsSetup";

// Notification Centre > Setup (R6.6): WhatsApp connection, Email (mode and the Email look), Languages, SMS / DLT.
const SUBS = [
    { key: "whatsapp", name: "WhatsApp", Component: WhatsAppTab },
    { key: "email", name: "Email", Component: EmailSetup },
    { key: "languages", name: "Languages", Component: LanguagesTab },
    { key: "sms", name: "SMS / DLT", Component: SmsSetup },
];

const SetupSection = ({ sub, carry, openTab, goSub }) => {
    const key = sub || carry?.sub;
    const active = SUBS.find((s) => s.key === key) || SUBS[0];
    const Active = active.Component;
    return (
        <div className="nc-setup">
            <div className="nc-sub-row">
                <nav className="nc-subnav" aria-label="Setup">
                    {SUBS.map((s) => <button key={s.key} type="button" className={`nc-subnav-btn ${s.key === active.key ? "is-active" : ""}`} aria-current={s.key === active.key ? "page" : undefined} onClick={() => goSub(s.key)}>{s.name}</button>)}
                </nav>
            </div>
            <Active openTab={openTab} />
        </div>
    );
};

export default SetupSection;
